import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import axios from "axios";
import { clearStoredSession } from "./helpers/AuthContext";

// Fix the baseURL logic
if (process.env.NODE_ENV === "development") {
  axios.defaults.baseURL = "http://localhost:8080";
} else {
  // In production, use relative URLs (same domain)
  axios.defaults.baseURL = "";
}

// Global request interceptor: attach the JWT (if logged in) to every
// outbound request as x-access-token. Without this, individual call
// sites have to remember to pass `headers: ctx.authHeader()` — which
// they didn't on /api/components/submit, /api/users/userlist, etc.
// After Phase 1b added auth to those endpoints, missing headers would
// produce 403s. This interceptor closes that gap once and for all.
axios.interceptors.request.use((config) => {
  try {
    const info = JSON.parse(localStorage.getItem("Info") || "null");
    const token = info && info.accessToken;
    if (token) {
      config.headers = config.headers || {};
      if (!config.headers["x-access-token"]) {
        config.headers["x-access-token"] = token;
      }
    }
  } catch (_) {
    // localStorage parse failure → no token, request goes out anonymous
  }
  return config;
});

// Global response interceptor: a 401 on a request that CARRIED a token
// means the server rejected the token itself (JWTs expire after 24h, or
// the signing secret rotated). The stored session is dead — without this
// handler the UI stays "logged in" while every API call silently fails
// (the label-page "Unauthorized!" bug). Clear the stale session and send
// the user to /login to re-authenticate.
//
// Exemptions:
//  - /api/auth/* — a wrong password on signin also returns 401; that must
//    surface in the form, not force a logout (the request interceptor
//    attaches the token to auth calls too, so the URL check is required).
//  - tokenless requests — guests hitting protected endpoints get their
//    error passed through untouched.
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response && error.response.status;
    const config = error.config || {};
    const sentToken = config.headers && config.headers["x-access-token"];
    const url = config.url || "";
    if (status === 401 && sentToken && !url.includes("/api/auth/")) {
      clearStoredSession();
      if (window.location.pathname !== "/login") {
        window.location.assign("/login?expired=1");
      }
    }
    return Promise.reject(error);
  }
);

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
